import GLightbox from 'glightbox';

const initLightbox = () => {
  const lightbox = GLightbox({
    selector: '.js-lightbox',
    touchNavigation: true,
    keyboardNavigation: true,
    loop: true,
    svg: {
      next: '<img src="./assets/img/home/arrow_next.svg" alt="" >',
      prev: '<img src="./assets/img/home/arrow_prev.svg" alt="" >',
      close: '<img src="./assets/img/home/arrow_close.svg" alt="" >',
    }
  });

  // GLightbox のクリック前にフォーカスを外す
  document.addEventListener("click", (e) => {
    if (e.target.closest(".js-lightbox")) {
      e.target.blur();
    }
  });

  return lightbox;
};

export default initLightbox;
